import * as React from "react";
import * as ReactQuery from "react-query";

import { LocalizationProvider, PresenterForScrollProvider } from "../Common";

import {
  ReactPlpInitialStateProvider,
  PlpPresenterForTheFilterMenuProvider,
  PlpPresenterForTheSortingMenuProvider,
  PlpPresenterForTheProductsMasonryProvider,
  PlpPresenterForRoutingTheResultsPageProvider,
  PlpAnalyticsProvider,
  PlpUrlStateProvider,
  PlpDataSourceUrlStateProvider,
  PlpDataTargetUrlStateProvider,
  PlpDataSourceProductListProvider,
  ProductListProvider,
} from "./providers";

import { PageContents } from "./PageContents";

interface AppProps {
  mountElement: Element | null;
}

const queryClient = new ReactQuery.QueryClient();

export const App: React.FunctionComponent<AppProps> = (props) => {
  const { mountElement } = props;
  return (
    <React.Fragment>
      <ReactQuery.QueryClientProvider client={queryClient}>
        <PresenterForScrollProvider>
          <ReactPlpInitialStateProvider mountElement={mountElement}>
            <LocalizationProvider>
              <PlpAnalyticsProvider>
                <PlpDataSourceProductListProvider>
                  <PlpDataSourceUrlStateProvider>
                    <PlpDataTargetUrlStateProvider>
                      <PlpUrlStateProvider>
                        <ProductListProvider>
                          <PlpPresenterForTheFilterMenuProvider>
                            <PlpPresenterForTheSortingMenuProvider>
                              <PlpPresenterForTheProductsMasonryProvider>
                                <PlpPresenterForRoutingTheResultsPageProvider>
                                  <PageContents />
                                </PlpPresenterForRoutingTheResultsPageProvider>
                              </PlpPresenterForTheProductsMasonryProvider>
                            </PlpPresenterForTheSortingMenuProvider>
                          </PlpPresenterForTheFilterMenuProvider>
                        </ProductListProvider>
                      </PlpUrlStateProvider>
                    </PlpDataTargetUrlStateProvider>
                  </PlpDataSourceUrlStateProvider>
                </PlpDataSourceProductListProvider>
              </PlpAnalyticsProvider>
            </LocalizationProvider>
          </ReactPlpInitialStateProvider>
        </PresenterForScrollProvider>
      </ReactQuery.QueryClientProvider>
    </React.Fragment>
  );
};
